import { createTheme } from '@material-ui/core/styles';

import palette from './palettes/default';
import bluePalette from "./palettes/blueTheme";
import darkBluePalette from "./palettes/darkBlueTheme";
import typography from './typography';
import overrides from './overrides';
import orangePalette from "./palettes/orangeTheme";
import defaultAppPalette from "./palettes/defaultTheme";

const defaultProps = {
    MuiButton: {
        size: 'small',
    },
    MuiTextField: {
        size: 'small',
    },
    MuiFormControl: {
        variant: 'outlined',
        size: 'small',
    },
    MuiSelect: {
        variant: 'outlined',
    },
    MuiPickersDatePicker: {
        inputVariant: 'outlined',
        size: 'small',
    },
    MuiPickersKeyboardDatePicker: {
        inputVariant: 'outlined',
        size: 'small',
    },
};

const theme = createTheme({
    palette,
    typography,
    overrides,
    props: defaultProps,
    zIndex: {
        appBar: 1200,
        drawer: 1100
    }
});

export const orangeTheme = createTheme({
    palette: orangePalette,
    typography,
    overrides,
    props: defaultProps,
    zIndex: {
        appBar: 1200,
        drawer: 1100
    }
});

export const blueTheme = createTheme({
    palette: bluePalette,
    typography,
    overrides,
    props: defaultProps,
    zIndex: {
        appBar: 1200,
        drawer: 1100
    }
});

export const darkBlueTheme = createTheme({
    palette: darkBluePalette,
    typography,
    overrides,
    props: defaultProps,
    zIndex: {
        appBar: 1200,
        drawer: 1100
    }
});

export const appDefaultTheme = createTheme({
    palette: defaultAppPalette,
    typography,
    overrides,
    props: defaultProps,
    zIndex: {
        appBar: 1200,
        drawer: 1100
    }
});


export default theme;
